export default __webpack_public_path__ + "static/media/ava-plug.262c7df2.jpg";